export const bankVerifyConfig = {
    bankVerify: 'Bank Verify',
    allowManualInput:'Bypass when verify fail'
}
